import type { IHttpRequest, IHttpResponse } from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  GetIncomeFromFplOptions,
  GetIncomeFromFplRequestDto,
  GetIncomeFromFplResponseDto,
} from './get-income-from-fpl.types';

export function getIncomeFromFPL(
  baseUrl: string,
  body: GetIncomeFromFplRequestDto,
  options?: GetIncomeFromFplOptions,
): Promise<IHttpResponse<GetIncomeFromFplResponseDto>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};
  const url = `${baseUrl}/api/quotes-api/v1/federal-poverty-level/income`;

  const request: IHttpRequest<GetIncomeFromFplRequestDto> = {
    url,
    method: 'POST',
    headers,
    body,
    schemas: {
      request: GetIncomeFromFplRequestDto,
      response: GetIncomeFromFplResponseDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
